import { useQuery } from '@tanstack/react-query';
import { fetchData } from '../../../utils';
import useSmartlook from '../../useSmartlook';

export type ClientPhoneData = {
  mobilePhone: string;
  status: string;
};

export async function getClientPhone() {
  return fetchData('/client/phone');
}

export default function useClientPhoneQuery(
  isEnabled = false,
  refetchInterval: number | false = false,
) {
  const { error } = useSmartlook();
  return useQuery<ClientPhoneData>({
    queryKey: ['client', 'phone'],
    queryFn: async () => {
      try {
        const data = await getClientPhone();
        return data;
      } catch (e) {
        error('[useClientQuery][GET /client/phone]', e);
        throw e;
      }
    },
    enabled: isEnabled,
    refetchInterval,
  });
}
